import { CoreFileLog } from '../../models';
import http, { HttpSuccessOrErrorType } from '../http';

export default {
    /**
     * 管理员调用 根据string_id生成餐馆核心文件
     * @param params 参数
     */
    async post_core_restaurant_aes_key(params: { restaurant_string_id: string, decryptedDeviceMac: string }): Promise<CoreFileLog> {
        const { restaurant_string_id, ...rest } = params;
        return await http.post(`/core/restaurant/${restaurant_string_id}/core-file-and-aes-key-by-admin`, {
            ...rest
        })
    },

    /**
     * 管理员根据string_id，获取餐馆RSA密钥
     * @param params 参数
     */
    async get_condiment_groups_private_key(params: { restaurant_string_id: string, decryptedDeviceMac: string }): Promise<HttpSuccessOrErrorType<unknown>> {
        const { restaurant_string_id, decryptedDeviceMac } = params;
        return await http.get(`/core/restaurant/${restaurant_string_id}/rsa-private-key-by-admin`, {
            params: {
                decryptedDeviceMac
            }
        })
    },


}